var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 169,
  height: 50,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M161.559 0H7.718C3.662 0 .374 3.292.374 7.353v35.294C.374 46.708 3.662 50 7.718 50h153.841c4.056 0 7.344-3.292 7.344-7.353V7.353c0-4.061-3.288-7.353-7.344-7.353Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M162.661 1a5.246 5.246 0 0 1 3.706 1.54 5.256 5.256 0 0 1 1.537 3.71v37.5a5.256 5.256 0 0 1-1.537 3.71 5.247 5.247 0 0 1-3.706 1.54H6.616a5.246 5.246 0 0 1-3.706-1.54 5.26 5.26 0 0 1-1.537-3.71V6.25A5.26 5.26 0 0 1 2.91 2.54 5.246 5.246 0 0 1 6.616 1h156.045Zm0-1H6.616a6.255 6.255 0 0 0-4.408 1.836A6.272 6.272 0 0 0 .374 6.25v37.5a6.272 6.272 0 0 0 1.834 4.414A6.256 6.256 0 0 0 6.616 50h156.045a6.257 6.257 0 0 0 4.409-1.836 6.275 6.275 0 0 0 1.833-4.414V6.25a6.275 6.275 0 0 0-1.833-4.414A6.257 6.257 0 0 0 162.661 0Z",
  fill: "#A6A6A6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.57 12.81a3.386 3.386 0 0 1-.93 2.5 3.635 3.635 0 0 1-2.752 1.11 3.933 3.933 0 0 1-3.595-2.443 3.945 3.945 0 0 1 .842-4.268 3.766 3.766 0 0 1 2.757-1.127 3.873 3.873 0 0 1 1.537.314c.453.182.855.469 1.175.838l-.658.66a2.528 2.528 0 0 0-2.056-.89 3.031 3.031 0 0 0-2.694 1.915 3.043 3.043 0 0 0 .65 3.244 2.98 2.98 0 0 0 4.137 0c.385-.415.608-.954.629-1.52h-2.725v-.9h3.63c.035.187.053.377.053.567ZM65.325 9.67h-3.412v2.376h3.075v.901h-3.075v2.378h3.41v.92h-4.369v-7.5h4.374l-.003.926ZM69.383 16.25h-.962V9.67h-2.093v-.92h5.14v.92h-2.085v6.58ZM75.199 16.25v-7.5h.962v7.5h-.962ZM80.431 16.25h-.963V9.67h-2.093v-.92h5.14v.92h-2.084v6.58ZM92.266 15.28a3.888 3.888 0 0 1-5.493 0 4.054 4.054 0 0 1 0-5.56 3.878 3.878 0 0 1 4.23-.844c.47.195.898.482 1.259.843a4.046 4.046 0 0 1 0 5.558l.004.004Zm-4.78-.628a2.875 2.875 0 0 0 4.068 0 3.198 3.198 0 0 0 0-4.305 2.878 2.878 0 0 0-4.069 0 3.2 3.2 0 0 0 0 4.305ZM94.719 16.25v-7.5h1.175l3.64 5.835h.042l-.041-1.445V8.75h.962v7.5h-1.002l-3.819-6.116h-.04l.04 1.445v4.671h-.957Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.434 27.19a5.305 5.305 0 0 0-4.89 3.296 5.323 5.323 0 0 0 1.163 5.786 5.308 5.308 0 0 0 9.057-3.766 5.245 5.245 0 0 0-3.28-4.939 5.226 5.226 0 0 0-2.05-.377Zm0 8.538a3.228 3.228 0 0 1-3.148-1.83 3.24 3.24 0 0 1 2.201-4.552 3.227 3.227 0 0 1 3.386 1.337c.365.538.56 1.173.558 1.823a3.082 3.082 0 0 1-1.81 2.954 3.07 3.07 0 0 1-1.187.27v-.002ZM73.808 27.19a5.304 5.304 0 0 0-4.89 3.296 5.323 5.323 0 0 0 1.163 5.786 5.308 5.308 0 0 0 9.057-3.766 5.247 5.247 0 0 0-3.28-4.938 5.229 5.229 0 0 0-2.05-.378Zm0 8.538a3.227 3.227 0 0 1-3.149-1.828 3.24 3.24 0 0 1 2.2-4.554 3.228 3.228 0 0 1 3.386 1.337 3.24 3.24 0 0 1 .559 1.823 3.08 3.08 0 0 1-1.81 2.954c-.373.168-.776.26-1.186.27v-.002Zm-13.83-6.912v2.255h5.39a4.717 4.717 0 0 1-1.228 2.84 5.519 5.519 0 0 1-4.163 1.654 5.99 5.99 0 0 1-4.238-1.758 6.005 6.005 0 0 1 0-8.488 5.99 5.99 0 0 1 4.238-1.757 5.739 5.739 0 0 1 4.063 1.617l1.589-1.59a7.855 7.855 0 0 0-5.652-2.277 8.237 8.237 0 0 0-5.902 2.379 8.257 8.257 0 0 0-2.454 5.877 8.266 8.266 0 0 0 2.454 5.878 8.244 8.244 0 0 0 5.902 2.379 7.53 7.53 0 0 0 5.753-2.316 8.15 8.15 0 0 0 1.83-6.686l-7.583-.007Zm56.561 1.752a4.94 4.94 0 0 0-4.546-3.383 5.041 5.041 0 0 0-4.704 3.31 5.055 5.055 0 0 0-.302 2.006 5.194 5.194 0 0 0 1.506 3.78 5.196 5.196 0 0 0 3.763 1.537 5.283 5.283 0 0 0 4.424-2.353l-1.81-1.208a3.029 3.029 0 0 1-2.614 1.47 2.695 2.695 0 0 1-2.574-1.617l7.099-2.94-.242-.602ZM109.3 32.34a2.917 2.917 0 0 1 2.776-3.102 2.056 2.056 0 0 1 1.969 1.128L109.3 32.34Zm-5.772 5.154h2.334v-15.62h-2.336l.002 15.62Zm-3.819-9.117h-.08a3.68 3.68 0 0 0-2.791-1.187 5.31 5.31 0 0 0-3.617 1.631 5.325 5.325 0 0 0 0 7.37 5.311 5.311 0 0 0 3.617 1.631 3.615 3.615 0 0 0 2.79-1.209h.081v.766c0 2.034-1.085 3.121-2.836 3.121a2.935 2.935 0 0 1-2.674-1.894l-2.033.846a5.066 5.066 0 0 0 4.7 3.14c2.735 0 5.048-1.617 5.048-5.536v-9.544h-2.21l.005.864Zm-2.676 7.352a3.23 3.23 0 0 1-2.947-3.222 3.237 3.237 0 0 1 2.947-3.223 3.243 3.243 0 0 1 2.837 3.223 3.25 3.25 0 0 1-2.837 3.222Zm30.437-13.854h-5.581V37.5h2.325v-5.92h3.252a4.85 4.85 0 0 0 4.725-2.932 4.864 4.864 0 0 0-2.787-6.485 4.851 4.851 0 0 0-1.938-.29l.004.002Zm.06 7.53h-3.316v-5.357h3.305a2.676 2.676 0 0 1 2.552 3.724 2.677 2.677 0 0 1-2.552 1.632l.011.002Zm14.393-2.243a4.37 4.37 0 0 0-4.156 2.392l2.068.864a2.206 2.206 0 0 1 2.128-1.146 2.244 2.244 0 0 1 2.45 2.012v.163a5.15 5.15 0 0 0-2.429-.603c-2.228 0-4.498 1.227-4.498 3.52a3.619 3.619 0 0 0 2.452 3.258c.458.154.941.215 1.423.178a3.28 3.28 0 0 0 2.971-1.53h.079v1.206h2.25v-5.992a4.283 4.283 0 0 0-1.398-3.23 4.279 4.279 0 0 0-3.341-1.092h.001Zm-.28 8.563c-.762 0-1.827-.38-1.827-1.324 0-1.205 1.322-1.669 2.469-1.669.743-.02 1.478.16 2.128.522a2.831 2.831 0 0 1-2.772 2.471h.002Zm13.218-8.222-2.672 6.775h-.079l-2.77-6.775h-2.51l4.157 9.469-2.368 5.268h2.429l6.404-14.737h-2.591Zm-20.982 10h2.328v-15.63h-2.328v15.63Z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.403 9.422a2.502 2.502 0 0 0-.579 1.756v27.647a2.502 2.502 0 0 0 .579 1.756l.092.09L28.96 25.177v-.365L13.49 9.333l-.087.089Z",
  fill: "url(#googlePlay_svg__a)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m34.115 30.349-5.155-5.165v-.365l5.155-5.162.116.067 6.109 3.474a1.895 1.895 0 0 1 1.31 1.805 1.899 1.899 0 0 1-1.31 1.804l-6.107 3.475-.117.067Z",
  fill: "url(#googlePlay_svg__b)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.233 30.28 28.958 25 13.402 40.58a2.028 2.028 0 0 0 2.593.076l18.237-10.377Z",
  fill: "url(#googlePlay_svg__c)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.233 19.722 15.997 9.347a2.028 2.028 0 0 0-2.594.076l15.554 15.578 5.276-5.279Z",
  fill: "url(#googlePlay_svg__d)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "m34.117 30.165-18.12 10.307a2.076 2.076 0 0 1-2.497.013l-.093.094.093.09a2.077 2.077 0 0 0 2.496-.013L34.233 30.28l-.116-.116Z",
  fill: "#000"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M13.403 40.397a2.503 2.503 0 0 1-.579-1.754v.186a2.502 2.502 0 0 0 .579 1.756l.092-.094-.092-.094ZM40.341 26.622l-6.227 3.541.116.116 6.108-3.475A2.188 2.188 0 0 0 41.647 25a2.327 2.327 0 0 1-1.306 1.622Z",
  fill: "#000"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "m15.996 9.53 24.345 13.85a2.324 2.324 0 0 1 1.309 1.617 2.193 2.193 0 0 0-1.309-1.805L15.996 9.347c-1.744-.993-3.172-.168-3.172 1.834v.182c0-1.996 1.428-2.826 3.172-1.834Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "googlePlay_svg__a",
  x1: 27.588,
  y1: 219.957,
  x2: 2.818,
  y2: 213.381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "googlePlay_svg__b",
  x1: 42.614,
  y1: 205.834,
  x2: 12.401,
  y2: 205.834,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "googlePlay_svg__c",
  x1: 31.358,
  y1: 203.107,
  x2: 11.427,
  y2: 169.614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "googlePlay_svg__d",
  x1: 9.487,
  y1: 230.761,
  x2: 18.392,
  y2: 215.802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.068,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})))));
export default SvgGooglePlay;